import { ChangePasswordView } from "app/components/changepassword/ChangePasswordView";

export const ChangePasswordRouterFactory = () => {
        return <ChangePasswordView />
}